<template>
   <v-form
    ref="form"
    v-model="valid"
    lazy-validation>
    <v-container>
      <v-alert type="warning" v-model="havealert" dismissible close-text="Close Alert">
          {{havemssgalert}}
      </v-alert>
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="12" xs="12" sm="8" md="6" lg="5" xl="4" style="max-width:380px">

            <v-text-field
              label="Email"
              v-model="email"
              :rules="emailRules"
              validate-on-blur
              outlined
              dense
              autocomplete="username"
              prepend-inner-icon="mdi-email-outline"
              @keyup.enter="login"
            ></v-text-field>
            <v-text-field
              label="Password"
              :type="prikaziLozinku ? 'text' : 'password'"
              v-model="password"
              :rules="[rules.required]"
              validate-on-blur
              outlined
              dense
              autocomplete="current-password"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="prikaziLozinku ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              @click:append="prikaziLozinku = !prikaziLozinku"
              @keyup.enter="login"
            ></v-text-field>
            <div>
              <span  style="color:red; font-weight:bold">{{error}}</span>
            </div>
            <br>
            <v-row align = "center">
              <v-col class="text-center" cols="12" sm="12">
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="login">
                Login
              </v-btn>
              <v-progress-circular v-if="this.saving"
                indeterminate
                color="green"
              ></v-progress-circular>
              </v-col>
            </v-row>

            <v-row align = "center">
              <v-col class="text-center" cols="12" sm="12">
              <v-btn text small color="primary"
                @click="register">
                Register new user
              </v-btn>

              <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                bottom
                :color="color"
                >
                {{ text }}
              </v-snackbar>

              </v-col>

            </v-row>
        </v-col>
      </v-row>
     <div v-if="showDialog">
      <JustWait :message="message" :showDialog="showDialog" />
    </div>
    </v-container>
  </v-form>
</template>

<script>
import UserService from '@/services/UserService'
import CompUserService from '@/services/CompUserService'
import CompService from '@/services/CompService'
import CompBusinessYearService from '@/services/CompBusinessYearService'
import Account4Service from '@/services/Account4Service'
// import Account3Service from '@/services/Account3Service'
// import Account2Service from '@/services/Account2Service'
// import Account1Service from '@/services/Account1Service'
import ItemService from '@/services/ItemService'
import GroupService from '@/services/GroupService'
import EmployeeService from '@/services/EmployeeService'
import MainLedgerProjectTypeService from '@/services/MainLedgerProjectTypeService'
import PartnerService from '@/services/PartnerService'
import WareHouseMarkService from '@/services/WareHouseMarkService'
import SalarieTaxFreeService from '@/services/SalarieTaxFreeService'
import {testLastUpdate} from '@/services/TestLastUpdate'
import JustWait from '../snippets/JustWait'
import KlasusService from '@/services/KlasusService'

export default {
  name: 'login',
  data () {
    return {
      saving: false,
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      valid: true,
      lazy: false,
      // Poruke su dvojezicne kao i ostale na ovom ekranu - prijavljuju se i
      // korisnici koji ne govore hrvatski.
      rules: {
        required: value => !!value || 'Obavezno / Required'
      },
      emailRules: [
        v => !!v || 'Upišite e-mail. / E-mail is required.',
        v => /.+@.+\..+/.test(v) || 'Neispravna e-mail adresa. / E-mail must be valid.'
      ],
      email: '',
      password: '',
      error: null,
      locError: 0,
      currentYear: 0,
      userHaveCompany: [],
      companyBY: [],
      defaultCompanyId: 0,
      mainQuery: {
        email: ''
      },
      mainQuery2: {
      },
      account1s: [],
      account2s: [],
      account3s: [],
      account4s: [],
      itemsLoc: [],
      groupsLoc: [],
      employes: [],
      havealert: false,
      havemssgalert: '',
      privateP: false,
      finance3: false,
      finance4: false,
      allowFin: false,
      message: '',
      showDialog: false,
      prikaziLozinku: false
    }
  },
  mounted () {
    this.message = 'Please wait...'
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        // this.snackbar = true
        this.login()
      }
    },
    async login () {

      try {
        this.locError = 0
        const response = await UserService.login({
          email: this.email,
          password: this.password
        })
        
        if (!response || !response.data || !response.data.user) {
          this.locError = 1
          this.javiGresku('Prijava nije uspjela. Pokušajte ponovno. / Login failed. Please try again.')
        }
        // Poruka mora ostati na ekranu: skok na "/" je vodio na istu stranicu,
        // a snackbar nestane za dvije sekunde pa korisnik ne vidi razlog.
        if (this.locError === 0 && response.data.user.Activ === false) {
          this.locError = 1
          this.javiGresku('Korisnik nije aktivan. Javite se administratoru. / User is not active. Please contact the administrator.')
        }
        if (this.locError === 0) {
          this.showDialog = true
          this.$store.dispatch('setToken', response.data.token)
          this.$store.dispatch('setUser', response.data.user)
          this.mainQuery.email = this.email
          //  -------------------------  Default Company
          // If have user, then choose default company
          //  -------------------------  Default Company

          await CompUserService.choose(this.mainQuery)
          .then (res => {
            if (res && res.data && res.data.companyUser) {
              this.userHaveCompany = res.data.companyUser
            }
          })
          .catch(err => {
            console.log('err', err)
          })
          //this.userHaveCompany = (await CompUserService.choose(this.mainQuery)).data.companyUser
          if (typeof this.userHaveCompany !== 'undefined' && this.userHaveCompany !== null && this.userHaveCompany.length > 0) {
            this.userHaveCompany.forEach(userComp => {
              if (userComp.defaultCompany) {
                this.defaultCompanyId = userComp.CompanyId
              }
            })
            // if user dont have default company then choose with first in array number
            if (this.defaultCompanyId === 0) {
              this.defaultCompanyId = this.userHaveCompany[0].CompanyId
            }
          } else {
            this.locError = 1
            this.javiGresku('Korisnik nema prava ni u jednoj firmi. Javite se administratoru. / User has no permissions in any company. Please contact the administrator.')

            this.$store.dispatch('setBusinessYear', null)
            this.$store.dispatch('setCompanyName', null)
            this.$store.dispatch('setCompanyid', null)
            this.$store.dispatch('setCompanyActiv', null)
            this.$store.dispatch('setToken', null)
            this.$store.dispatch('setUser', null)
            this.$store.dispatch('setProjectTypes', null)
            this.$store.dispatch('setDateItems', null)
            this.$store.dispatch('setDatePartners', null)
            this.$store.dispatch('setDateAccounts', null)
            this.$store.dispatch('setWareHouseMarkid', null)
            this.$store.dispatch('setWarehouseState', null)
            this.$store.dispatch('setKlasus', null)
            this.showDialog = false
            // this.$router.push({
            //   path: '/'
            // })
          }
        }
        //  -------------------------  BusinessYear
        // have a companyId then find all company data
        //  -------------------------  BusinessYear

        if (this.locError === 0) {
          this.mainQuery2.CompanyId = this.defaultCompanyId
          this.currentYear = new Date().getFullYear()
          this.companyBY = (await CompBusinessYearService.choose(this.mainQuery2)).data.companyBY
          if (this.companyBY) {
            this.companyBY.forEach(compBY => {
              if (compBY.defaultBusinessYear) {
                this.currentYear = compBY.BusinessYear
              }
            })
          } else {
            this.text = 'Business Year is NOT set for these company! Default current year!'
            this.color = 'red'
            this.snackbar = true
          }

          //  -------------------------  Company data object
          const locCompSelect = (await CompService.show(this.defaultCompanyId)).data.company
          //  -------------------------  Set all to Store
          this.$store.dispatch('setCompanyid', locCompSelect.id)
          this.$store.dispatch('setCompanyName', locCompSelect.CompanyNameDatabase)
          this.$store.dispatch('setCompanyActiv', locCompSelect)
          this.$store.dispatch('setBusinessYear', this.currentYear)
          this.$store.dispatch('setWareHouseMarkid', 1)
          // when have company, then use company default business year
          this.saving = true

          await ItemService.index(this.mainQuery2).then(res => {
            if (res.data.items) {
              this.$store.dispatch('setDateItems', new Date())
              this.$store.dispatch('setActivItems', res.data.items)
            }
          })
          .catch(err => {
            this.havealert = !this.havealert
            this.havemssgalert = 'Error on init Items ' + err
          })

          await GroupService.index(this.mainQuery2).then(res => {
            if (res.data.groups) {
              this.$store.dispatch('setActivGroups', res.data.groups)
            }
          })
          .catch(err => {
            this.havealert = !this.havealert
            this.havemssgalert = 'Error on init Groups ' + err
          })

          await EmployeeService.index(this.mainQuery2).then(res => {
            if (res.data.employes) {
              this.$store.dispatch('setActivEmployes', res.data.employes)
            }
          })
          .catch(err => {
            console.log('Error init Employees ', err)
          })

          await MainLedgerProjectTypeService.index2(this.mainQuery2).then(res => {
            if (res.data.mainledgerprojecttype) {
              this.$store.dispatch('setProjectTypes', res.data.mainledgerprojecttype)
            }
          })
          .catch(err => {
            console.log('Error init MainLedgerProjectTypes ', err)
          })

          await WareHouseMarkService.index(this.mainQuery2).then(res => {
            if (res.data.wareHouseMarks) {
              this.$store.dispatch('setWarehouseState', res.data.wareHouseMarks)
            }
          })
          .catch(err => {
            console.log('Error init setWarehouseState ', err)
          })

          await KlasusService.indexfast(this.mainQuery2).then(res => {
            if (res.data.items) {
              this.$store.dispatch('setKlasus', res.data.items)
            }
          })
          .catch(err => {
            console.log('Error init setKlasus ', err)
          })

          this.mainQuery2.noPageing = 0
          const privateP = this.$store.state.user && this.$store.state.user.privatePartner ? this.$store.state.user.privatePartner : false
          const {data} = privateP ? (await PartnerService.index2(this.mainQuery2)) : (await PartnerService.index(this.mainQuery2))

          if (data && data.partners && data.partners.rows) {
            this.$store.dispatch('setDatePartners', new Date())
            this.$store.dispatch("setPartners", data.partners.rows)
          }
          this.privateP = this.$store.state.user && this.$store.state.user.privatePartner ? this.$store.state.user.privatePartner : false
          this.finance3 = "finance3" in this.$store.state.user ? this.$store.state.user.finance3 : true

          if (this.finance3) {
            this.allowFin = true
          }
          if (this.allowFin) {
             await Account4Service.index(this.mainQuery2).then(res => {
              if (res.data.account4s) {
                  this.$store.dispatch('setDateAccounts', new Date())
                  this.$store.dispatch('setAccount4s', res.data.account4s)
                }
              })
              .catch(err => {
                this.havealert = !this.havealert
                this.havemssgalert = 'Error on init account4s ' + err
              })
              this.mainQuery2.BusinessYear = new Date().getFullYear()
              await SalarieTaxFreeService.index(this.mainQuery2).then(res => {
              if (res.data.salarieTaxFrees) {
                  this.$store.dispatch('setJoppdNotaxAll', res.data.salarieTaxFrees)
                }
              })
              .catch(err => {
                this.havealert = !this.havealert
                this.havemssgalert = 'Error on init JoppdNotaxAll ' + err
              })
          }

          this.saving = false
          await testLastUpdate()
          this.showDialog = false
 
          if (this.$route.name !== 'home') {
            this.$router.push({
              name: 'home'
            })
          }
        }
      } catch (error) {
        // Kad server ne odgovara, "error.response" ne postoji - citanje
        // "error.response.data" tada baci novu gresku i korisnik ne vidi nista.
        const odgovor = error && error.response ? error.response : null
        let poruka = 'Server nije dostupan. Pokušajte ponovno. / Server is not available. Please try again.'
        if (odgovor) {
          // 403 je uvijek "krivi podaci"; serverova engleska poruka ovdje ne
          // govori nista vise od toga.
          poruka = odgovor.status === 403
            ? 'Neispravan email ili lozinka. / Incorrect email or password.'
            : (odgovor.data && odgovor.data.message ? odgovor.data.message : 'Prijava nije uspjela. / Login failed.')
        }
        this.javiGresku(poruka)
      }
      this.saving = false
    },
    // Greske kod prijave ostaju na ekranu dok ih korisnik ne zatvori; lozinka
    // se brise da se ne prijavljuje ponovno s istom krivom.
    javiGresku (poruka) {
      this.havemssgalert = poruka
      this.havealert = true
      this.showDialog = false
      this.saving = false
      this.password = ''
    },
    register () {
      this.$router.push({
        name: 'userregister'
      })
    },
    async writeDatePartners() {
      await this.$store.dispatch('setDatePartners', new Date())
    }
  },
  computed: {

  },
  watch: {

  },
  components: {
    JustWait
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
